type EnvRecord = Record<string, string | boolean | undefined>;

function readFromImportMeta(key: string): string | undefined {
  if (typeof import.meta === 'undefined') return undefined;
  const env = import.meta.env as EnvRecord | undefined;
  const value = env?.[key];
  return typeof value === 'string' ? value : undefined;
}

function readFromProcess(key: string): string | undefined {
  if (typeof process === 'undefined') return undefined;
  const value = process.env?.[key];
  return typeof value === 'string' ? value : undefined;
}

export function readEnvString(key: string, fallback = ''): string {
  return (readFromImportMeta(key) ?? readFromProcess(key) ?? fallback).trim();
}

export function readEnvBoolean(key: string, fallback = false): boolean {
  const normalized = readEnvString(key).toLowerCase();

  if (!normalized) return fallback;
  if (['1', 'true', 'yes', 'on'].includes(normalized)) return true;
  if (['0', 'false', 'no', 'off'].includes(normalized)) return false;

  return fallback;
}

export function isDevEnvironment(): boolean {
  if (typeof import.meta !== 'undefined' && typeof import.meta.env?.DEV === 'boolean') {
    return import.meta.env.DEV;
  }
  if (typeof process !== 'undefined' && typeof process.env?.NODE_ENV === 'string') {
    return process.env.NODE_ENV !== 'production';
  }
  return false;
}
